import { render, staticRenderFns } from "./PartnerMarketingEventForm.vue?vue&type=template&id=39da47c5&scoped=true&"
import script from "./PartnerMarketingEventForm.vue?vue&type=script&lang=js&"
export * from "./PartnerMarketingEventForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnerMarketingEventForm.vue?vue&type=style&index=0&id=39da47c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da47c5",
  null
  
)

export default component.exports